export default __webpack_public_path__ + "static/media/photo--lg--namrata-4.49c103d3.jpg";